import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import * as actions from '../redux/actions';
import { CollectionRouteConfig } from '..';
import { UtilityConfig } from './UtilityConfig';

export class CollectionConfig extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  renderAccordion = (collectionId, collectionName, children) => {
    return (
      <AccordionItem key={collectionId} uuid={collectionId}>
        <AccordionItemState>
          {({ expanded }) => (
            <>
              <AccordionItemHeading
                className="gjs-block-category"
                style={{
                  color: 'black',
                  width: '75vw',
                }}
              >
                <AccordionItemButton
                  className="gjs-title bg-light border-0 border-light"
                  style={{
                    borderBottom: 'none',
                    padding: '7px 5px 7px 10px',
                  }}
                >
                  <span
                    className={
                      expanded
                        ? 'gjs-caret-icon fa fa-caret-down'
                        : 'gjs-caret-icon fa fa-caret-right'
                    }
                  ></span>
                  <span style={{ fontSize: '15px' }}>{collectionName}</span>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel style={{ padding: '20px' }}>{children}</AccordionItemPanel>
            </>
          )}
        </AccordionItemState>
      </AccordionItem>
    );
  };

  renderCollectionAccordion = () => {
    const { appSetting, projectId, version, isReadOnly } = this.props;
    const { projectCollections, projectDetail, projectDevApis } = appSetting;
    if (!projectCollections && !projectCollections.length) {
      return '';
    }
    const { enableEncryption } = projectDetail;
    return projectCollections.map((collection) => {
      const children = (
        <CollectionRouteConfig
          projectId={projectId}
          version={version}
          collection={collection}
          enableEncryption={enableEncryption}
          isReadOnly={isReadOnly}
        />
      );
      return this.renderAccordion(collection.uuid, collection.collectionName, children);
    });
  };

  renderUtilityAccordion = () => {
    const { projectId, version, appSetting, isReadOnly } = this.props;
    const { projectDevApis } = appSetting;
    const children = (
      <UtilityConfig
        projectId={projectId}
        version={version}
        projectDevApis={projectDevApis}
        isReadOnly={isReadOnly}
      />
    );
    return this.renderAccordion('Utility', 'Utility', children);
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-1 col-lg-1 col-sm-1"></div>
        <div className="col-md-7 col-lg-7 col-sm-7 row mb-3 d-flex align-items-end">
          <Accordion allowZeroExpanded preExpanded={['DEVELOPERAPIS']}>
            {this.renderCollectionAccordion()}
            {this.renderUtilityAccordion()}
          </Accordion>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionConfig);
